export default __webpack_public_path__ + "static/media/noData.d1f1795e.png";